import { render, staticRenderFns } from "./AppGov.vue?vue&type=template&id=52e743ae&scoped=true&"
import script from "./AppGov.vue?vue&type=script&lang=js&"
export * from "./AppGov.vue?vue&type=script&lang=js&"
import style0 from "./AppGov.vue?vue&type=style&index=0&id=52e743ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e743ae",
  null
  
)

export default component.exports